<template>
  <div>
    <div class="Rectangle">
      <p>
        <span class="info-icon">i</span> Upload digitally signed form 16. Signature can be done on all the pages or first/last page or on the alternate pages or odd/even pages.
      </p>
    </div>
    <div class="paygrpsDiv">
      <div class="alignPaygrp">
        <span>Total Employees</span>
        <br />
        <div class="paygrps-info">
          <b>0</b>
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Folder uploaded</span>
        <br />
        <div class="paygrps-info">
          <b>0</b>
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Files uploaded</span>
        <br />
        <div class="paygrps-info">
          <b>0</b>
        </div>
      </div>
      <div class="alignPaygrp">
        <span>File mismatch</span>
        <br />
        <div class="paygrps-info">
          <b>0</b>
        </div>
      </div>
    </div>
    <div class="threeColumnGrid">
      <upload />
    </div>
    <div class="singleColumnGrid margintop-30">
      <tl-checkbox label="Email Form 16" name="emailForm16" id="emailForm16"></tl-checkbox>
      <tl-checkbox label="Publish Form 16 in ESS" name="publishForm16" id="publishForm16"></tl-checkbox>
      <tl-checkbox
        label="Password prtotect files (password is PAN number in upper case)"
        name="passwordFile"
        id="passwordFile"
      ></tl-checkbox>
    </div>
    <div class="singleColumnGrid margintop-30">
      <span>
        <a href="#">Click here</a>
        <span class="disabled">&nbsp;to download digital signature tool</span>
      </span>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Form16_May_2019 folder submitted successfully.`"
      btnText="Back to Form 16 Annexure"
      @back="backfrompopup()"
    />
    <bottom-action-container>
      <btn-grp slot="end">
        <btn text="Back" type="secondary" class v-on:click="back"></btn>
        <btn text="Submit" type="primary" class v-on:click="submitForm"></btn>
      </btn-grp>
    </bottom-action-container>
  </div>
</template>
<script>
export default {
  name: "UploadFormAnnexure",
  data() {
    return {
      showSuccessMsg: false
    };
  },
  methods: {
    download() {},
    back() {},
    submitForm() {
      this.showSuccessMsg = true;
    },
    backfrompopup() {
      this.showSuccessMsg = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.Rectangle {
  width: 100%;
  padding: 15px;
  border-radius: 4px;
  background-color: #f9f9f9;
  p {
    margin: 0px;
    font-size: 12px;
  }
}
.info-icon {
border: 1px #646464 solid;
border-radius: 100%;
width: 20px;
height: 20px;
margin: 0 5px 0 0;
display: inline-block;
vertical-align: middle;
font-size: 15px;
color: #646464;
}
.paygrpsDiv {
  display: flex;
  cursor: pointer;
  grid-template-columns: repeat(4/2fr);
  grid-template-rows: auto;
  grid-gap: 2px;
  padding: 40px 0px;

  span {
    color: #646464;
    font-size: 16px;
  }
}
.paygrps-info {
  color: #646464;
  cursor: pointer;
  text-align: center;
  b {
    font-size: 24px;
  }
}
.alignPaygrp {
  margin-right: 5%;
}
</style>
